/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { Permission } from '../../features/common/permision';
import { SkillTable } from '../../features/skill/components/skill-table';

export const Route = createFileRoute('/_creator-center/skills')({
  staticData: { permissions: [Permission.管理技能包] },
  component: SkillsPage,
});

function SkillsPage() {
  return <SkillTable />;
}
